<template>
  <UiField name="order_comments" label="Notes de commande">
    <textarea id="order_comments" name="order_comments" placeholder="Commentaires concernant votre commande ou instructions spéciales." rows="3" cols="5" />
  </UiField>
</template>
